<script>
import Layout from "../../layouts/main";
import ConnectCard from "../../../components/connectCard";
import FacebookOverview from "../../../components/facebookOverview";
import axios from "axios";
import {mapGetters, mapState} from "vuex";
import FacebookPosts from "../../../components/facebookPosts";
import Swal from "sweetalert2";

export default {
  page: {
    title: "Facebook",
    meta: [{ name: "description", content: '' }],
  },
  components: {
    FacebookPosts,
    Layout,
    ConnectCard,
    FacebookOverview
  },
  data() {
    return {
      authResponse: {},
      pages: [],
      showError: false,
      errorMessage: 'Something went wrong.',
      showModal: false
    };
  },
  computed: {
    ...mapState('user', {
      user: (state) => state.user
    }),
    ...mapGetters('user', ['facebookConnected', 'hasFacebookTokenError']),
    facebook() {
      return this.user.social_network_accounts && this.user.social_network_accounts.facebook;
    },
    connected() {
      return this.facebook;
    },
    initialTab () {
      return this.$route.query.tab;
    }
  },
  created () {
    window.fbAsyncInit = function() {
      FB.init({
        appId            : '1201960090286776',
        autoLogAppEvents : true,
        xfbml            : true,
        version          : 'v11.0'
      });
    };
    this.addFacebookScript();
  },
  methods: {
    fbLogin() {
      this.$store.commit('loader/START_LOADING');
      FB.login((response) => {
        // handle the response
        this.authResponse = response.authResponse;
        if (response.status === 'connected') {
          this.getPermissions();
        } else {
          this.$store.commit('loader/END_LOADING');
        }

      }, {scope: 'pages_read_engagement,instagram_basic,instagram_manage_insights,pages_show_list,read_insights,pages_manage_metadata,pages_read_user_content'});
    },
    getPermissions() {
      FB.api('/me/permissions', (response) => {
        var declined = [];
        for (let i = 0; i < response.data.length; i++) {
          if (response.data[i].status === 'declined') {
            declined.push(response.data[i].permission)
          }
        }
        if(declined.length > 0) {
          this.$store.commit('loader/END_LOADING');
          this.errorMessage = 'Requested permissions are declined.';
          this.showError = true;
        } else {
          this.getPagesList();
        }
      });
    },
    getPagesList () {
      FB.api(
              `/${this.authResponse.userID}/accounts`,
              'GET', {
                fields: "instagram_business_account{biography,id,ig_id,followers_count,follows_count,media_count,name,profile_picture_url,username,website},access_token,id,about,bio,picture,category,name"
              },
      (response) => {
          if (response && !response.error) {
            if (response.data.length > 0) {
              this.pages = response.data;

              if (this.facebookConnected) {
                const pageIds = this.pages.map(page => page.id);
                if (pageIds.includes(this.user.social_network_accounts.facebook.id)) {
                  this.choosePage(this.user.social_network_accounts.facebook.id);
                } else {
                  const availablePageNames = this.pages.map(page => page.name).join(', ');
                  Swal.fire("Error!", `The connected page is not on the list of available pages. Available pages: ${availablePageNames}`, "error");
                }
              } else {
                this.showModal = true;
              }
            } else {
              this.errorMessage = 'No facebook pages connected with this user.';
              this.showError = true;
            }
          } else {
            this.errorMessage = 'Something went wrong while connecting with facebook.';
            this.showError = true;
          }
        this.$store.commit('loader/END_LOADING');
        }
      );
    },
    addFacebookScript () {
      const facebookScript = document.createElement('script');
      facebookScript.setAttribute('src', 'https://connect.facebook.net/sr_RS/sdk.js');
      facebookScript.setAttribute('async','');
      facebookScript.setAttribute('defer','');
      facebookScript.setAttribute('crossorigin', 'anonymous');
      document.body.appendChild(facebookScript);
    },
    async choosePage (pageID) {
      this.$store.commit('loader/START_LOADING');
      try{
        const url = this.connected ? '/profile/facebook/update-token' : '/profile/facebook/connect'
        await axios.post(url, {
          access_token:  this.authResponse.accessToken,
          page_id: pageID
        }, );
        window.location = '/facebook';
      } catch (err) {
        this.errorMessage = 'Something went wrong.';
        this.showError = true;
      } finally {
        this.$store.commit('loader/END_LOADING');
        this.showModal = false;
      }
    }
  }
};
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <b-alert
                v-model="showError"
                class="mt-3"
                variant="danger"
                dismissible
        >{{ errorMessage }}</b-alert>
      </div>
    </div>
    <div v-if="hasFacebookTokenError" class="row">
      <div class="col-12">
        <b-alert
            class="mt-3"
            variant="danger"
            show=""
            dismissible
        >
          <p>Your facebook token expired!</p>
          <button @click="fbLogin" class="btn btn-sm btn-success">Update token</button>
        </b-alert>
      </div>
    </div>
    <div v-if="connected" class="row">
        <div class="col">
          <div class="card">
            <div class="card-body">
              <b-tabs nav-class="nav-tabs-custom" content-class="text-muted">
                <b-tab :active="!initialTab">
                  <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-chart-bar"></i>
                  </span>
                    <span class="d-none d-sm-inline-block">Overview</span>
                  </template>

                  <FacebookOverview />

                </b-tab>
                <b-tab :active="initialTab === 'posts'">
                  <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="far fa-images"></i>
                  </span>
                    <span class="d-none d-sm-inline-block">Posts</span>
                  </template>

                  <FacebookPosts />

                </b-tab>
              </b-tabs>
            </div>
          </div>
        </div>
    </div>
    <div v-else class="row">
      <div class="col">
        <ConnectCard social-network="Facebook" @connect="fbLogin"/>
      </div>
    </div>

    <b-modal v-model="showModal" :title="`Choose your account`" size="lg" hide-footer centered>
      <div class="row my-5 justify-content-center">
        <div class="col-8">
          <button v-for="page in pages" :key="page.name" @click="choosePage(page.id)" class="btn btn-block btn-primary my-3 btn-facebook">
            <img
                class="rounded-circle header-profile-user mr-3"
                :src="page.picture.data.url"
                alt="Header Avatar"
            />
            {{ page.name }}
          </button>
        </div>
      </div>
    </b-modal>
  </Layout>
</template>
